import { TextField } from '@mui/material';
import { GridRenderEditCellParams } from '@mui/x-data-grid-pro';
import { ChangeEvent, FC } from 'react';

const EMPTY_VALUE = '';

interface CustomTextAreaEditProps extends GridRenderEditCellParams {}

const CustomTextAreaEdit: FC<CustomTextAreaEditProps> = (props) => {
    const { api, field, id, value, hasFocus } = props;

    const handleChange = ({ target }: ChangeEvent<HTMLInputElement>) => {
        api.setEditCellValue({ id, field, value: target.value });
    };

    return (
        <TextField
            multiline
            rows={3}
            onChange={handleChange}
            value={value === EMPTY_VALUE ? '' : value}
            autoFocus={hasFocus}
            fullWidth
            variant="standard"
            sx={{
                '& .MuiInputBase-root': {
                    padding: '8px 16px',
                },
            }}
        />
    );
};

export default CustomTextAreaEdit;
